export const TRANSACTION_TYPE = {
    DEPOSIT: 'DEPOSIT',
    RETURN: 'RETURN',
    WITHDRAWAL: 'WITHDRAWAL',
    PURCHASE: 'PURCHASE',
    SALE: 'SALE',
    AFFILIATE_PURCHASE: 'AFFILIATE_PURCHASE',
    SURVEY: 'SURVEY',
    PAYMENT_REQUEST: 'PAYMENT_REQUEST',
} as const;
